import { UPDATE_CORE_CHAT_TOKEN } from '../actions';

export function coreChatToken(state = '', action) {
  switch (action.type) {
    case UPDATE_CORE_CHAT_TOKEN: {
      return action.coreChatToken;
    }
    default:
      return state;
  }
}
